import { React, useState, Fragment, useEffect, useRef } from 'react';
import { useForm, Controller, useNa } from 'react-hook-form';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import EditIcon from '@mui/icons-material/Edit';
import { Switch } from '@mui/material';
import ImageKit from 'imagekit';

const Company = () => {
    const [toast, setToast] = useState();
    const [oldInvBg, setOldInvBg] = useState();
    const [newInvBg, setNewInvBg] = useState();
    const prevValueRef = useRef();

    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        //resolver: yupResolver(validationSchema),
    });

    const setImage = (e) => {
        if (e) {
            let file = e.target.files[0]
            var reader = new FileReader()
            let src = ''
            reader.onloadend = function () {
                var data = reader.result.split(',')[1]
                src = 'data:image/png;base64,' + data
                setValue(e.target.name, src)
            }
            reader.readAsDataURL(file)
        }
    }

    const getData = () => {
        apiService().get("settings").then(response => {
            const fields = Object.keys(response.data[0]);
            fields.map((field) => {
                setValue(field, response.data[0][field])
                if (field === "InvoiceBg") {
                    setOldInvBg(response.data[0][field])
                }
            }
            );
        })
    }

    const watchFieldValue = watch('InvoiceBg');

    const onSubmit = (data) => {
        data.Logo = !data.Logo ? "" : data.Logo;
        if (oldInvBg !== watchFieldValue) {
            invoiceBgUpload(newInvBg, data)
        }
        else {
            save(data)
        }
    };

    const imagekit = new ImageKit({
        publicKey: 'public_dtg79aNXLn+bDjjq8+MwLFGtCag=',
        privateKey: 'private_5R+LGyau4GnMmgSQJ+T0XTs5H8w=',
        urlEndpoint: 'https://ik.imagekit.io/t3solutions',
    });

    const invoiceBgUpload = async (e, data) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const response = await imagekit.upload({
                    file,
                    fileName: file.name,
                });
                data.InvoiceBg = response.url
                save(data)
                deleteImage(oldInvBg)
                console.log('Image uploaded:', response);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    const deleteImage = async (oldImageUrl) => {
        try {
            const response = await imagekit.deleteFile(oldImageUrl);
            console.log('Old image deleted:', response);
        } catch (error) {
            console.error('Error deleting old image:', error);
        }
    };

    const save = (data) => {
        apiService().put('settings', data)
            .then((response) => {
                if (response.success) {
                    setToast({
                        open: true,
                        message: 'U ruajten me sukses!',
                        variant: 'success',
                    });
                } else {
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
            });
    }

    useEffect(() => {
        getData()
    }, [])

    // useEffect(() => {
    //     if (prevValueRef.current !== watchFieldValue) {
    //         console.log('Field value has changed');
    //     }
    // }, [watchFieldValue])


    return (
        <div className="">
            <Fragment>
                <Toast {...toast} />
                <TopActions
                    newHref="/workerlist/addworker"
                    save={handleSubmit(onSubmit)}
                />

                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Company Data
                        </Typography>
                        <form>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <div class="avatar-upload">
                                        <div class="avatar-edit">
                                            <input
                                                error={errors.Logo}
                                                control={control}
                                                onChange={(e) => setImage(e)}
                                                type="file"
                                                id="imageUpload"
                                                name="Logo"
                                            />
                                            <label for="imageUpload" id="imgLabel"><EditIcon /></label>
                                        </div>
                                        <div class="avatar-preview">
                                            <div id="imagePreview"
                                                style={{ backgroundImage: `url(${watch('Logo')})` }}>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Emri i kompanisë"
                                        error={errors.CompanyName}
                                        control={control}
                                        register={{ ...register('CompanyName') }}
                                        name="CompanyName"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="NUI"
                                        error={errors.NUI}
                                        control={control}
                                        register={{ ...register('NUI') }}
                                        name="NUI"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Banka"
                                        error={errors.BankName}
                                        control={control}
                                        register={{ ...register('BankName') }}
                                        name="BankName"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Xhirollogaria"
                                        error={errors.BankAccount}
                                        control={control}
                                        register={{ ...register('BankAccount') }}
                                        name="BankAccount"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Email"
                                        error={errors.Email}
                                        control={control}
                                        register={{ ...register('Email') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Telefoni"
                                        error={errors.Phone}
                                        control={control}
                                        register={{ ...register('Phone') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Adresa"
                                        error={errors.Address}
                                        control={control}
                                        register={{ ...register('Address') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Shteti"
                                        error={errors.Country}
                                        control={control}
                                        register={{ ...register('Country') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Qyteti"
                                        error={errors.City}
                                        control={control}
                                        register={{ ...register('City') }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <div style={{ marginTop: 20 }}>
                                        <small >Invoice background</small>
                                        <div class="invoice-bg avatar-upload">
                                            <div class="avatar-edit">
                                                <input
                                                    error={errors.InvoiceBg}
                                                    control={control}
                                                    //onChange={(e) => setImage(e)}
                                                    onChange={(e) => { setImage(e); setNewInvBg(e) }}
                                                    type="file"
                                                    id="invoiceBgImg"
                                                    name="InvoiceBg"
                                                />
                                                <label for="invoiceBgImg" id="invoiceImgLabel"><EditIcon /></label>
                                            </div>
                                            <div class="invoice-bg-preview avatar-preview">
                                                <div id="invoiceImagePreview"
                                                    style={{ backgroundImage: `url(${watch('InvoiceBg')})` }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Fragment>
        </div>
    )
}

export default Company